import React, { useRef } from "react";
import Slider from "react-slick";

const TestimonialsFive = () => {
  const sliderRef = useRef(null);
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 900,
    dots: false,
    pauseOnHover: true,
    arrows: false,
    draggable: false,
    infinite: true,
    centerMode: true,
    centerPadding: "0px",

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  const testimonials = [
    {
      text: "Vibe Research Solution sangat membantu saya dalam proses penulisan jurnal Scopus. Tim konsultan sangat profesional dan memahami standar publikasi internasional dengan baik.",
      name: "Dr. Amanda Putri",
      role: "Dosen Universitas",
      image: "assets/images/thumbs/guru/3.png",
      bgColor: "bg-main-200"
    },
    {
      text: "Konsultasi metodologi penelitian yang diberikan sangat membantu dalam pengerjaan disertasi saya. Pendampingan intensif dan masukan yang konstruktif membuat penelitian saya lebih terarah.",
      name: "M. Rizki, M.Sc",
      role: "Kandidat Doktor",
      image: "assets/images/thumbs/guru/4.png",
      bgColor: "bg-danger-200"
    },
    {
      text: "Layanan pengolahan data yang cepat dan akurat. Tim Vibe Research Solution membantu saya menganalisis data penelitian dengan metode yang tepat dan interpretasi yang mendalam.",
      name: "Indah Wulandari, S.E.",
      role: "Mahasiswa S2",
      image: "assets/images/thumbs/guru/3.png",
      bgColor: "bg-success-200"
    }
  ];

  return (
    <section className='position-relative z-4 bg-main-25 w-100 h-100'>
      <div className='position-absolute w-100  top-0 start-0'>
        <img
          src='assets/images/shapes/cloud-shap-img3.png'
          alt=''
          className='w-100'
        />
      </div>
      <div className='py-120 position-relative z-3'>
        <div className='container'>
          <div className='max-w-611 text-center mx-auto mb-60'>
            <div
              className='text-main-600 fw-semibold text-xl d-flex align-items-center gap-8 mb-16 justify-content-center flex-wrap'
              data-aos='fade-down'
            >
              <span>
                <i className='ph-bold ph-star' />
              </span>
              <span>Testimonial</span>
            </div>
            <h2 className='mb-24 wow bounceIn'>
              Apa Kata Mereka Tentang Vibe Research
            </h2>
            <p className='max-w-557-px text-md text-neutral-700 fw-normal wow bounceInUp'>
              Dengarkan pengalaman langsung dari akademisi dan peneliti yang telah menggunakan layanan konsultasi penelitian kami
            </p>
          </div>

          <Slider
            ref={sliderRef}
            {...settings}
            className='tastimonial-six-slider d-flex align-items-center gap-24 mb-40'
          >
            {testimonials.map((testimonial, index) => (
              <div key={index} className=''>
                <div className={`triangle-shape z-2 text-center px-28 pt-32 pb-32 mb-64 ${testimonial.bgColor} rounded-pill position-relative`}>
                  <ul className='mb-16 d-flex align-items-center gap-8 text-center justify-content-center'>
                    {[...Array(5)].map((_, i) => (
                      <li key={i} className='text-24 text-warning-500'>
                        <img
                          src='assets/images/icons/testimonials-six-icon-start-img1.png'
                          alt='Rating Star'
                        />
                      </li>
                    ))}
                  </ul>
                  <p className='text-center justify-content-center align-items-center d-flex text-neutral-700 fw-medium text-18'>
                    "{testimonial.text}"
                  </p>
                </div>
                <div className='text-center pt-24'>
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className='mb-16 justify-content-center mx-auto w-72 h-72'
                  />
                  <h5 className='fw-semibold mb-4'>{testimonial.name}</h5>
                  <span className='text-neutral-500 fw-normal text-16'>
                    {testimonial.role}
                  </span>
                </div>
              </div>
            ))}
          </Slider>
          <div className=' d-flex align-items-center gap-16 text-center justify-content-center'>
            <button
              type='button'
              id='tastimonial-six-prev'
              onClick={() => sliderRef.current.slickPrev()}
              className=' w-48 h-48 border-main-600 border text-main-600 rounded-circle text-24 align-items-center justify-content-center d-flex hover-bg-main-600 hover-text-white transition-04'
            >
              <i className='ph ph-caret-left' />
            </button>
            <button
              type='button'
              id='tastimonial-six-next'
              onClick={() => sliderRef.current.slickNext()}
              className=' w-48 h-48 border-main-600 border text-main-600 rounded-circle text-24 align-items-center justify-content-center d-flex hover-bg-main-600 hover-text-white transition-04'
            >
              <i className='ph ph-caret-right' />
            </button>
          </div>
        </div>
      </div>
      <div className='position-absolute w-100 z-0 bottom-0 start-0'>
        <img
          src='assets/images/shapes/cloud-shap-img4.png'
          alt=''
          className='w-100'
        />
      </div>
    </section>
  );
};

export default TestimonialsFive;
